<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col lg="12" class="ml-auto">
      <b-card-group deck>
        <b-card
          bg-variant="primary"
          text-variant="white"
          v-b-tooltip="{
            title: 'برای ورود کلیک نمایید',
            placement: 'bottom',
            variant: 'primary',
          }"
          style="cursor: pointer"
          @click="gotoOrders()"
        >
          <v-row>
            <v-col cols="8">
              <h3>
                <h2>
                  <b-badge variant="defualt"></b-badge>
                </h2>
                <b-card-text>
                  پیگیری سفارش‌ها
                  <br />
                  <br />
                </b-card-text>
              </h3>
            </v-col>
            <v-col cols="4">
              <h3 class="text-left">
                <i class="fa fa-object-ungroup"></i>
              </h3>
            </v-col>
          </v-row>
        </b-card>

        <b-card
          bg-variant="success"
          text-variant="white"
          v-b-tooltip="{
            title: 'برای ورود کلیک نمایید',
            placement: 'bottom',
            variant: 'success',
          }"
          style="cursor: pointer"
          @click="gotoArchive()"
        >
          <v-row>
            <v-col cols="8">
              <h3>
                <h2>
                  <b-badge variant="defualt"></b-badge>
                </h2>
                <b-card-text>
                  آرشیو سفارش‌ها
                  <br />
                  <br />
                </b-card-text>
              </h3>
            </v-col>
            <v-col cols>
              <h3 class="text-left">
                <i class="fa fa-hourglass"></i>
              </h3>
            </v-col>
          </v-row>
        </b-card> </b-card-group
    ></v-col>
    <b-card header-bg-variant="primary" header-text-variant="white">
      <template v-slot:header>
        <h4>آخرین سفارش‌های ثبت شده</h4>
      </template>
      <br />
      <b-card class="shadow p-3 mb-5 bg-white rounded">
        <b-table
          responsive
          show-empty
          :items="lastItems"
          :fields="fields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
          :busy="isBusy"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>

          <template v-slot:cell(progress)="data">
            <b-progress
              :value="data.item.progress"
              variant="success"
              :striped="striped"
              show-progress
              animated
            ></b-progress>
          </template>
          <template v-slot:cell(operation)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-btn
                variant="primary"
                class="mr-1"
                @click="gotoOrder(data.item)"
                >جزییات</b-btn
              >
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>
      </b-card>
      <br />
    </b-card>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import Var from "../../../variables";
import router from "../../router";

export default {
  components: {},
  data: function () {
    return {
      guide: false,
      file: "",
      content: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      lastItems: [],
      fields: [
        // { key: "subject", label: "عنوان استعلام" },
        { key: "customerName", label: "نام مشتری" },
        { key: "code", label: "کد ردیابی" },
        { key: "registerDate", label: "تاریخ" },
        { key: "factoryStatus", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      selected: ["step1"],
      options: [
        { text: "مرحله 1", value: "step1" },
        { text: "مرحله 2", value: "step2" },
        { text: "مرحله3 ", value: "step3" },
      ],

      selectedTime: "on",
      customer_count: "-",
      order_count: "-",
      userName: "",
      name: "",
      striped: true,
      isBusy: false,
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    showLastOrders() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/orders/dashboard",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.lastItems = res.data;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    gotoOrders() {
      this.$router.push("/factory/orders");
    },
    gotoArchive() {
      this.$router.push("/factory/ordersArchive");
    },
    gotoOrder(order) {
      this.$router.push("/factory/order/" + order.id);
    },
  },

  mounted() {
    this.showLastOrders();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
